export const flightsData = [
    {
        "company name": "Ryanair",
        "date": "08/12/2024",
        "price": 997,
        "destination": "Hong Kong"
    },
    {
        "company name": "EasyJet",
        "date": "08/09/2024",
        "price": 708,
        "destination": "Singapore"
    },
    {
        "company name": "Blue Air",
        "date": "08/15/2024",
        "price": 500,
        "destination": "Toronto"
    },
    {
        "company name": "Wizz-Air",
        "date": "01/10/2024",
        "price": 397,
        "destination": "London"
    },
    {
        "company name": "Wizz-Air",
        "date": "06/16/2024",
        "price": 995,
        "destination": "Sydney"
    },
    {
        "company name": "EasyJet",
        "date": "05/30/2024",
        "price": 789,
        "destination": "New York"
    },
    {
        "company name": "Wizz-Air",
        "date": "11/16/2024",
        "price": 311,
        "destination": "Toronto"
    },
    {
        "company name": "Ryanair",
        "date": "09/25/2024",
        "price": 889,
        "destination": "Chicago"
    },
    {
        "company name": "Blue Air",
        "date": "02/27/2024",
        "price": 472,
        "destination": "Chicago"
    },
    {
        "company name": "Blue Air",
        "date": "02/08/2024",
        "price": 773,
        "destination": "Dubai"
    },
    {
        "company name": "Blue Air",
        "date": "12/20/2024",
        "price": 669,
        "destination": "Beijing"
    },
    {
        "company name": "British Airways",
        "date": "04/15/2024",
        "price": 995,
        "destination": "Singapore"
    },
    {
        "company name": "Blue Air",
        "date": "03/24/2024",
        "price": 268,
        "destination": "Dubai"
    },
    {
        "company name": "Wizz-Air",
        "date": "09/14/2024",
        "price": 186,
        "destination": "Sydney"
    },
    {
        "company name": "Wizz-Air",
        "date": "08/25/2024",
        "price": 450,
        "destination": "Hong Kong"
    },
    {
        "company name": "Ryanair",
        "date": "05/09/2024",
        "price": 494,
        "destination": "Sydney"
    },
    {
        "company name": "EasyJet",
        "date": "09/24/2024",
        "price": 298,
        "destination": "Beijing"
    },
    {
        "company name": "Ryanair",
        "date": "01/21/2024",
        "price": 536,
        "destination": "London"
    },
    {
        "company name": "British Airways",
        "date": "05/05/2024",
        "price": 892,
        "destination": "Dubai"
    },
    {
        "company name": "Blue Air",
        "date": "05/27/2024",
        "price": 368,
        "destination": "London"
    },
    {
        "company name": "Wizz-Air",
        "date": "11/05/2024",
        "price": 969,
        "destination": "Beijing"
    },
    {
        "company name": "British Airways",
        "date": "04/06/2024",
        "price": 604,
        "destination": "Hong Kong"
    },
    {
        "company name": "EasyJet",
        "date": "12/10/2024",
        "price": 148,
        "destination": "Paris"
    },
    {
        "company name": "British Airways",
        "date": "07/02/2024",
        "price": 540,
        "destination": "Moscow"
    },
    {
        "company name": "Blue Air",
        "date": "10/15/2024",
        "price": 887,
        "destination": "Toronto"
    },
    {
        "company name": "EasyJet",
        "date": "05/13/2024",
        "price": 462,
        "destination": "Singapore"
    },
    {
        "company name": "Ryanair",
        "date": "07/30/2024",
        "price": 546,
        "destination": "Madrid"
    },
    {
        "company name": "EasyJet",
        "date": "06/13/2024",
        "price": 257,
        "destination": "Beijing"
    },
    {
        "company name": "EasyJet",
        "date": "05/16/2024",
        "price": 848,
        "destination": "Bangkok"
    },
    {
        "company name": "EasyJet",
        "date": "01/19/2024",
        "price": 605,
        "destination": "Los Angeles"
    },
    {
        "company name": "Ryanair",
        "date": "01/07/2024",
        "price": 293,
        "destination": "Sydney"
    },
    {
        "company name": "Blue Air",
        "date": "10/22/2024",
        "price": 836,
        "destination": "Chicago"
    },
    {
        "company name": "British Airways",
        "date": "09/05/2024",
        "price": 179,
        "destination": "Bangkok"
    },
    {
        "company name": "Ryanair",
        "date": "05/01/2024",
        "price": 717,
        "destination": "Sydney"
    },
    {
        "company name": "Wizz-Air",
        "date": "12/02/2024",
        "price": 361,
        "destination": "London"
    },
    {
        "company name": "British Airways",
        "date": "10/06/2024",
        "price": 650,
        "destination": "Bangkok"
    },
    {
        "company name": "EasyJet",
        "date": "11/17/2024",
        "price": 669,
        "destination": "Singapore"
    },
    {
        "company name": "Wizz-Air",
        "date": "12/08/2024",
        "price": 610,
        "destination": "Beijing"
    },
    {
        "company name": "Blue Air",
        "date": "09/21/2024",
        "price": 648,
        "destination": "Madrid"
    },
    {
        "company name": "Wizz-Air",
        "date": "02/02/2024",
        "price": 704,
        "destination": "Hong Kong"
    },
    {
        "company name": "Wizz-Air",
        "date": "06/15/2024",
        "price": 102,
        "destination": "Beijing"
    },
    {
        "company name": "Wizz-Air",
        "date": "08/21/2024",
        "price": 565,
        "destination": "Tokyo"
    },
    {
        "company name": "Blue Air",
        "date": "01/02/2024",
        "price": 536,
        "destination": "Beijing"
    },
    {
        "company name": "British Airways",
        "date": "06/14/2024",
        "price": 150,
        "destination": "Tokyo"
    },
    {
        "company name": "Wizz-Air",
        "date": "11/15/2024",
        "price": 123,
        "destination": "Beijing"
    },
    {
        "company name": "Ryanair",
        "date": "08/19/2024",
        "price": 971,
        "destination": "Sydney"
    },
    {
        "company name": "Ryanair",
        "date": "05/26/2024",
        "price": 585,
        "destination": "Dubai"
    },
    {
        "company name": "Ryanair",
        "date": "05/24/2024",
        "price": 831,
        "destination": "Singapore"
    },
    {
        "company name": "Ryanair",
        "date": "04/10/2024",
        "price": 143,
        "destination": "Moscow"
    },
    {
        "company name": "EasyJet",
        "date": "06/21/2024",
        "price": 949,
        "destination": "Bangkok"
    },
    {
        "company name": "EasyJet",
        "date": "07/08/2024",
        "price": 359,
        "destination": "London"
    },
    {
        "company name": "Blue Air",
        "date": "03/11/2024",
        "price": 813,
        "destination": "Dubai"
    },
    {
        "company name": "Ryanair",
        "date": "04/10/2024",
        "price": 720,
        "destination": "Madrid"
    },
    {
        "company name": "British Airways",
        "date": "08/18/2024",
        "price": 869,
        "destination": "Chicago"
    },
    {
        "company name": "British Airways",
        "date": "06/26/2024",
        "price": 879,
        "destination": "Toronto"
    },
    {
        "company name": "Ryanair",
        "date": "04/06/2024",
        "price": 404,
        "destination": "Sydney"
    },
    {
        "company name": "British Airways",
        "date": "11/06/2024",
        "price": 691,
        "destination": "Tokyo"
    },
    {
        "company name": "Wizz-Air",
        "date": "11/13/2024",
        "price": 146,
        "destination": "Dubai"
    },
    {
        "company name": "Blue Air",
        "date": "04/20/2024",
        "price": 644,
        "destination": "Singapore"
    },
    {
        "company name": "British Airways",
        "date": "11/13/2024",
        "price": 307,
        "destination": "Paris"
    },
    {
        "company name": "Blue Air",
        "date": "01/20/2024",
        "price": 190,
        "destination": "Los Angeles"
    },
    {
        "company name": "Ryanair",
        "date": "01/03/2024",
        "price": 449,
        "destination": "Toronto"
    },
    {
        "company name": "Ryanair",
        "date": "08/12/2024",
        "price": 118,
        "destination": "Dubai"
    },
    {
        "company name": "British Airways",
        "date": "02/06/2024",
        "price": 338,
        "destination": "Madrid"
    },
    {
        "company name": "British Airways",
        "date": "08/21/2024",
        "price": 344,
        "destination": "London"
    },
    {
        "company name": "Ryanair",
        "date": "07/06/2024",
        "price": 876,
        "destination": "Singapore"
    },
    {
        "company name": "Ryanair",
        "date": "07/09/2024",
        "price": 470,
        "destination": "Dubai"
    },
    {
        "company name": "Ryanair",
        "date": "02/01/2024",
        "price": 839,
        "destination": "Moscow"
    },
    {
        "company name": "EasyJet",
        "date": "03/10/2024",
        "price": 951,
        "destination": "Toronto"
    },
    {
        "company name": "British Airways",
        "date": "11/12/2024",
        "price": 856,
        "destination": "Beijing"
    },
    {
        "company name": "EasyJet",
        "date": "09/03/2024",
        "price": 830,
        "destination": "Chicago"
    },
    {
        "company name": "Ryanair",
        "date": "07/01/2024",
        "price": 189,
        "destination": "Paris"
    },
    {
        "company name": "Ryanair",
        "date": "07/18/2024",
        "price": 591,
        "destination": "Toronto"
    },
    {
        "company name": "Ryanair",
        "date": "01/29/2024",
        "price": 872,
        "destination": "Dubai"
    },
    {
        "company name": "British Airways",
        "date": "07/15/2024",
        "price": 670,
        "destination": "Chicago"
    },
    {
        "company name": "EasyJet",
        "date": "08/23/2024",
        "price": 462,
        "destination": "Bangkok"
    },
    {
        "company name": "Ryanair",
        "date": "08/18/2024",
        "price": 706,
        "destination": "Paris"
    },
    {
        "company name": "Blue Air",
        "date": "12/02/2024",
        "price": 665,
        "destination": "London"
    },
    {
        "company name": "British Airways",
        "date": "11/14/2024",
        "price": 851,
        "destination": "Los Angeles"
    },
    {
        "company name": "Blue Air",
        "date": "04/08/2024",
        "price": 360,
        "destination": "Madrid"
    },
    {
        "company name": "Ryanair",
        "date": "10/14/2024",
        "price": 452,
        "destination": "Chicago"
    },
    {
        "company name": "EasyJet",
        "date": "03/14/2024",
        "price": 762,
        "destination": "Los Angeles"
    },
    {
        "company name": "EasyJet",
        "date": "07/30/2024",
        "price": 586,
        "destination": "Sydney"
    },
    {
        "company name": "Ryanair",
        "date": "07/05/2024",
        "price": 664,
        "destination": "Sydney"
    },
    {
        "company name": "British Airways",
        "date": "06/19/2024",
        "price": 531,
        "destination": "Tokyo"
    },
    {
        "company name": "Blue Air",
        "date": "08/01/2024",
        "price": 503,
        "destination": "Singapore"
    },
    {
        "company name": "British Airways",
        "date": "01/13/2024",
        "price": 745,
        "destination": "New York"
    },
    {
        "company name": "British Airways",
        "date": "07/01/2024",
        "price": 130,
        "destination": "Tokyo"
    },
    {
        "company name": "Wizz-Air",
        "date": "05/28/2024",
        "price": 708,
        "destination": "Moscow"
    },
    {
        "company name": "Blue Air",
        "date": "06/27/2024",
        "price": 167,
        "destination": "Singapore"
    },
    {
        "company name": "EasyJet",
        "date": "04/10/2024",
        "price": 643,
        "destination": "Tokyo"
    },
    {
        "company name": "Wizz-Air",
        "date": "02/12/2024",
        "price": 818,
        "destination": "Tokyo"
    },
    {
        "company name": "Blue Air",
        "date": "05/05/2024",
        "price": 495,
        "destination": "Hong Kong"
    },
    {
        "company name": "EasyJet",
        "date": "12/06/2024",
        "price": 454,
        "destination": "Tokyo"
    },
    {
        "company name": "Blue Air",
        "date": "11/02/2024",
        "price": 552,
        "destination": "Dubai"
    },
    {
        "company name": "Ryanair",
        "date": "08/06/2024",
        "price": 341,
        "destination": "Chicago"
    },
    {
        "company name": "EasyJet",
        "date": "08/09/2024",
        "price": 628,
        "destination": "Hong Kong"
    },
    {
        "company name": "British Airways",
        "date": "05/12/2024",
        "price": 743,
        "destination": "Tokyo"
    },
    {
        "company name": "Blue Air",
        "date": "05/07/2024",
        "price": 705,
        "destination": "Chicago"
    },
    {
        "company name": "Blue Air",
        "date": "06/08/2024",
        "price": 427,
        "destination": "Moscow"
    },
    {
        "company name": "Wizz-Air",
        "date": "07/17/2024",
        "price": 440,
        "destination": "Sydney"
    },
    {
        "company name": "British Airways",
        "date": "02/28/2024",
        "price": 628,
        "destination": "Tokyo"
    },
    {
        "company name": "Ryanair",
        "date": "08/25/2024",
        "price": 783,
        "destination": "Los Angeles"
    },
    {
        "company name": "Wizz-Air",
        "date": "07/22/2024",
        "price": 848,
        "destination": "Los Angeles"
    },
    {
        "company name": "British Airways",
        "date": "06/18/2024",
        "price": 316,
        "destination": "London"
    },
    {
        "company name": "EasyJet",
        "date": "10/01/2024",
        "price": 618,
        "destination": "Tokyo"
    },
    {
        "company name": "Blue Air",
        "date": "01/28/2024",
        "price": 146,
        "destination": "Sydney"
    },
    {
        "company name": "Blue Air",
        "date": "12/29/2024",
        "price": 215,
        "destination": "Paris"
    },
    {
        "company name": "Ryanair",
        "date": "04/08/2024",
        "price": 170,
        "destination": "New York"
    },
    {
        "company name": "EasyJet",
        "date": "10/31/2024",
        "price": 904,
        "destination": "Toronto"
    },
    {
        "company name": "Blue Air",
        "date": "11/05/2024",
        "price": 136,
        "destination": "Paris"
    },
    {
        "company name": "Ryanair",
        "date": "04/16/2024",
        "price": 825,
        "destination": "Sydney"
    },
    {
        "company name": "Ryanair",
        "date": "10/25/2024",
        "price": 539,
        "destination": "Dubai"
    },
    {
        "company name": "Ryanair",
        "date": "01/24/2024",
        "price": 885,
        "destination": "Bangkok"
    },
    {
        "company name": "Blue Air",
        "date": "10/30/2024",
        "price": 324,
        "destination": "Bangkok"
    },
    {
        "company name": "Ryanair",
        "date": "07/28/2024",
        "price": 155,
        "destination": "London"
    },
    {
        "company name": "Wizz-Air",
        "date": "06/22/2024",
        "price": 318,
        "destination": "Los Angeles"
    },
    {
        "company name": "British Airways",
        "date": "03/27/2024",
        "price": 304,
        "destination": "Paris"
    },
    {
        "company name": "Ryanair",
        "date": "01/02/2024",
        "price": 415,
        "destination": "Toronto"
    },
    {
        "company name": "British Airways",
        "date": "08/18/2024",
        "price": 481,
        "destination": "Sydney"
    },
    {
        "company name": "Ryanair",
        "date": "06/09/2024",
        "price": 176,
        "destination": "Chicago"
    },
    {
        "company name": "British Airways",
        "date": "12/24/2024",
        "price": 281,
        "destination": "Bangkok"
    },
    {
        "company name": "Wizz-Air",
        "date": "03/02/2024",
        "price": 529,
        "destination": "Madrid"
    },
    {
        "company name": "Ryanair",
        "date": "01/08/2024",
        "price": 958,
        "destination": "Sydney"
    },
    {
        "company name": "British Airways",
        "date": "05/09/2024",
        "price": 708,
        "destination": "Dubai"
    },
    {
        "company name": "British Airways",
        "date": "01/30/2024",
        "price": 155,
        "destination": "Madrid"
    },
    {
        "company name": "Ryanair",
        "date": "06/01/2024",
        "price": 830,
        "destination": "Moscow"
    },
    {
        "company name": "Blue Air",
        "date": "09/29/2024",
        "price": 627,
        "destination": "Toronto"
    },
    {
        "company name": "EasyJet",
        "date": "06/07/2024",
        "price": 919,
        "destination": "Dubai"
    },
    {
        "company name": "Blue Air",
        "date": "02/14/2024",
        "price": 653,
        "destination": "Hong Kong"
    },
    {
        "company name": "British Airways",
        "date": "04/19/2024",
        "price": 544,
        "destination": "London"
    },
    {
        "company name": "Ryanair",
        "date": "07/08/2024",
        "price": 137,
        "destination": "Bangkok"
    },
    {
        "company name": "British Airways",
        "date": "09/17/2024",
        "price": 395,
        "destination": "Dubai"
    },
    {
        "company name": "Blue Air",
        "date": "05/28/2024",
        "price": 880,
        "destination": "New York"
    },
    {
        "company name": "Ryanair",
        "date": "07/31/2024",
        "price": 586,
        "destination": "Toronto"
    },
    {
        "company name": "Blue Air",
        "date": "06/15/2024",
        "price": 133,
        "destination": "Paris"
    },
    {
        "company name": "Ryanair",
        "date": "05/14/2024",
        "price": 198,
        "destination": "Toronto"
    },
    {
        "company name": "Wizz-Air",
        "date": "05/13/2024",
        "price": 366,
        "destination": "Beijing"
    },
    {
        "company name": "Wizz-Air",
        "date": "07/25/2024",
        "price": 486,
        "destination": "Paris"
    },
    {
        "company name": "Blue Air",
        "date": "07/22/2024",
        "price": 228,
        "destination": "London"
    },
    {
        "company name": "Blue Air",
        "date": "09/11/2024",
        "price": 557,
        "destination": "Hong Kong"
    },
    {
        "company name": "Blue Air",
        "date": "03/22/2024",
        "price": 480,
        "destination": "Singapore"
    },
    {
        "company name": "Wizz-Air",
        "date": "12/05/2024",
        "price": 141,
        "destination": "Los Angeles"
    },
    {
        "company name": "Ryanair",
        "date": "07/25/2024",
        "price": 671,
        "destination": "Paris"
    },
    {
        "company name": "Wizz-Air",
        "date": "02/04/2024",
        "price": 572,
        "destination": "London"
    },
    {
        "company name": "British Airways",
        "date": "06/24/2024",
        "price": 791,
        "destination": "Moscow"
    },
    {
        "company name": "EasyJet",
        "date": "09/22/2024",
        "price": 374,
        "destination": "Tokyo"
    },
    {
        "company name": "Ryanair",
        "date": "02/21/2024",
        "price": 151,
        "destination": "Bangkok"
    },
    {
        "company name": "EasyJet",
        "date": "08/25/2024",
        "price": 973,
        "destination": "London"
    },
    {
        "company name": "British Airways",
        "date": "03/14/2024",
        "price": 566,
        "destination": "Tokyo"
    },
    {
        "company name": "British Airways",
        "date": "08/05/2024",
        "price": 576,
        "destination": "Beijing"
    },
    {
        "company name": "Wizz-Air",
        "date": "12/18/2024",
        "price": 792,
        "destination": "Chicago"
    },
    {
        "company name": "British Airways",
        "date": "07/29/2024",
        "price": 755,
        "destination": "London"
    },
    {
        "company name": "Wizz-Air",
        "date": "07/07/2024",
        "price": 971,
        "destination": "London"
    },
    {
        "company name": "Blue Air",
        "date": "11/11/2024",
        "price": 719,
        "destination": "Hong Kong"
    },
    {
        "company name": "Wizz-Air",
        "date": "11/27/2024",
        "price": 219,
        "destination": "Sydney"
    },
    {
        "company name": "Ryanair",
        "date": "07/02/2024",
        "price": 307,
        "destination": "New York"
    },
    {
        "company name": "British Airways",
        "date": "09/30/2024",
        "price": 526,
        "destination": "Madrid"
    },
    {
        "company name": "Blue Air",
        "date": "10/10/2024",
        "price": 331,
        "destination": "Toronto"
    },
    {
        "company name": "Wizz-Air",
        "date": "03/01/2024",
        "price": 846,
        "destination": "Dubai"
    },
    {
        "company name": "Blue Air",
        "date": "02/17/2024",
        "price": 387,
        "destination": "London"
    },
    {
        "company name": "British Airways",
        "date": "09/08/2024",
        "price": 500,
        "destination": "Sydney"
    },
    {
        "company name": "British Airways",
        "date": "05/25/2024",
        "price": 255,
        "destination": "Toronto"
    },
    {
        "company name": "Wizz-Air",
        "date": "09/19/2024",
        "price": 255,
        "destination": "Sydney"
    },
    {
        "company name": "EasyJet",
        "date": "04/06/2024",
        "price": 904,
        "destination": "Tokyo"
    },
    {
        "company name": "EasyJet",
        "date": "11/08/2024",
        "price": 403,
        "destination": "Beijing"
    },
    {
        "company name": "Ryanair",
        "date": "01/02/2024",
        "price": 622,
        "destination": "Los Angeles"
    },
    {
        "company name": "Wizz-Air",
        "date": "12/11/2024",
        "price": 840,
        "destination": "Bangkok"
    },
    {
        "company name": "EasyJet",
        "date": "04/02/2024",
        "price": 970,
        "destination": "Moscow"
    },
    {
        "company name": "Wizz-Air",
        "date": "11/25/2024",
        "price": 715,
        "destination": "Hong Kong"
    },
    {
        "company name": "British Airways",
        "date": "02/04/2024",
        "price": 660,
        "destination": "Toronto"
    },
    {
        "company name": "Blue Air",
        "date": "07/29/2024",
        "price": 425,
        "destination": "Bangkok"
    },
    {
        "company name": "Ryanair",
        "date": "08/24/2024",
        "price": 427,
        "destination": "Paris"
    },
    {
        "company name": "British Airways",
        "date": "01/03/2024",
        "price": 263,
        "destination": "Paris"
    },
    {
        "company name": "Blue Air",
        "date": "10/02/2024",
        "price": 390,
        "destination": "Chicago"
    },
    {
        "company name": "Ryanair",
        "date": "02/26/2024",
        "price": 660,
        "destination": "Sydney"
    },
    {
        "company name": "British Airways",
        "date": "01/07/2024",
        "price": 966,
        "destination": "Bangkok"
    },
    {
        "company name": "EasyJet",
        "date": "12/28/2024",
        "price": 793,
        "destination": "Sydney"
    },
    {
        "company name": "Ryanair",
        "date": "06/22/2024",
        "price": 121,
        "destination": "Toronto"
    },
    {
        "company name": "Wizz-Air",
        "date": "01/26/2024",
        "price": 885,
        "destination": "Moscow"
    },
    {
        "company name": "Ryanair",
        "date": "06/27/2024",
        "price": 368,
        "destination": "London"
    },
    {
        "company name": "British Airways",
        "date": "09/26/2024",
        "price": 506,
        "destination": "Bangkok"
    },
    {
        "company name": "Wizz-Air",
        "date": "09/11/2024",
        "price": 198,
        "destination": "Bangkok"
    },
    {
        "company name": "Ryanair",
        "date": "12/28/2024",
        "price": 909,
        "destination": "New York"
    },
    {
        "company name": "Ryanair",
        "date": "06/01/2024",
        "price": 957,
        "destination": "New York"
    },
    {
        "company name": "British Airways",
        "date": "01/06/2024",
        "price": 636,
        "destination": "London"
    },
    {
        "company name": "British Airways",
        "date": "08/30/2024",
        "price": 142,
        "destination": "Bangkok"
    },
    {
        "company name": "Wizz-Air",
        "date": "09/16/2024",
        "price": 655,
        "destination": "Dubai"
    },
    {
        "company name": "EasyJet",
        "date": "01/22/2024",
        "price": 796,
        "destination": "Tokyo"
    },
    {
        "company name": "Wizz-Air",
        "date": "12/27/2024",
        "price": 913,
        "destination": "Dubai"
    },
    {
        "company name": "Blue Air",
        "date": "10/24/2024",
        "price": 963,
        "destination": "Dubai"
    },
    {
        "company name": "EasyJet",
        "date": "01/14/2024",
        "price": 128,
        "destination": "Madrid"
    },
    {
        "company name": "Ryanair",
        "date": "07/02/2024",
        "price": 665,
        "destination": "Beijing"
    },
    {
        "company name": "Blue Air",
        "date": "07/10/2024",
        "price": 882,
        "destination": "Beijing"
    },
    {
        "company name": "Ryanair",
        "date": "06/12/2024",
        "price": 536,
        "destination": "Moscow"
    },
    {
        "company name": "Ryanair",
        "date": "04/26/2024",
        "price": 173,
        "destination": "Los Angeles"
    },
    {
        "company name": "British Airways",
        "date": "06/08/2024",
        "price": 683,
        "destination": "Bangkok"
    },
    {
        "company name": "Wizz-Air",
        "date": "02/18/2024",
        "price": 187,
        "destination": "Bangkok"
    },
    {
        "company name": "British Airways",
        "date": "02/24/2024",
        "price": 670,
        "destination": "Beijing"
    },
    {
        "company name": "Blue Air",
        "date": "03/24/2024",
        "price": 869,
        "destination": "Singapore"
    },
    {
        "company name": "Ryanair",
        "date": "03/29/2024",
        "price": 356,
        "destination": "Hong Kong"
    },
    {
        "company name": "Blue Air",
        "date": "09/13/2024",
        "price": 343,
        "destination": "Madrid"
    },
    {
        "company name": "Blue Air",
        "date": "01/14/2024",
        "price": 210,
        "destination": "Hong Kong"
    },
    {
        "company name": "EasyJet",
        "date": "10/22/2024",
        "price": 750,
        "destination": "Paris"
    },
    {
        "company name": "EasyJet",
        "date": "07/09/2024",
        "price": 667,
        "destination": "Paris"
    },
    {
        "company name": "British Airways",
        "date": "04/15/2024",
        "price": 513,
        "destination": "Sydney"
    },
    {
        "company name": "Blue Air",
        "date": "06/26/2024",
        "price": 297,
        "destination": "Madrid"
    },
    {
        "company name": "Blue Air",
        "date": "11/28/2024",
        "price": 307,
        "destination": "Los Angeles"
    },
    {
        "company name": "Ryanair",
        "date": "04/30/2024",
        "price": 949,
        "destination": "Madrid"
    },
    {
        "company name": "Ryanair",
        "date": "04/27/2024",
        "price": 537,
        "destination": "New York"
    },
    {
        "company name": "Wizz-Air",
        "date": "08/28/2024",
        "price": 908,
        "destination": "Sydney"
    },
    {
        "company name": "Blue Air",
        "date": "03/10/2024",
        "price": 788,
        "destination": "Sydney"
    },
    {
        "company name": "Wizz-Air",
        "date": "02/14/2024",
        "price": 936,
        "destination": "Paris"
    },
    {
        "company name": "Blue Air",
        "date": "08/12/2024",
        "price": 780,
        "destination": "Bangkok"
    },
    {
        "company name": "Wizz-Air",
        "date": "02/24/2024",
        "price": 164,
        "destination": "Los Angeles"
    },
    {
        "company name": "EasyJet",
        "date": "10/19/2024",
        "price": 582,
        "destination": "Beijing"
    },
    {
        "company name": "EasyJet",
        "date": "10/14/2024",
        "price": 909,
        "destination": "Toronto"
    },
    {
        "company name": "Ryanair",
        "date": "01/26/2024",
        "price": 541,
        "destination": "New York"
    },
    {
        "company name": "British Airways",
        "date": "10/27/2024",
        "price": 166,
        "destination": "London"
    },
    {
        "company name": "EasyJet",
        "date": "03/27/2024",
        "price": 876,
        "destination": "Dubai"
    },
    {
        "company name": "British Airways",
        "date": "07/23/2024",
        "price": 203,
        "destination": "Tokyo"
    },
    {
        "company name": "British Airways",
        "date": "11/06/2024",
        "price": 492,
        "destination": "Beijing"
    },
    {
        "company name": "Ryanair",
        "date": "08/19/2024",
        "price": 905,
        "destination": "Hong Kong"
    },
    {
        "company name": "EasyJet",
        "date": "04/05/2024",
        "price": 895,
        "destination": "London"
    },
    {
        "company name": "Wizz-Air",
        "date": "08/10/2024",
        "price": 862,
        "destination": "Hong Kong"
    },
    {
        "company name": "Wizz-Air",
        "date": "05/30/2024",
        "price": 350,
        "destination": "New York"
    },
    {
        "company name": "British Airways",
        "date": "03/22/2024",
        "price": 624,
        "destination": "Sydney"
    },
    {
        "company name": "Wizz-Air",
        "date": "09/20/2024",
        "price": 480,
        "destination": "New York"
    },
    {
        "company name": "British Airways",
        "date": "06/09/2024",
        "price": 502,
        "destination": "Sydney"
    },
    {
        "company name": "British Airways",
        "date": "04/24/2024",
        "price": 446,
        "destination": "Singapore"
    },
    {
        "company name": "Ryanair",
        "date": "11/15/2024",
        "price": 604,
        "destination": "Hong Kong"
    },
    {
        "company name": "Ryanair",
        "date": "06/08/2024",
        "price": 655,
        "destination": "Beijing"
    },
    {
        "company name": "Blue Air",
        "date": "02/22/2024",
        "price": 621,
        "destination": "Beijing"
    },
    {
        "company name": "British Airways",
        "date": "10/08/2024",
        "price": 598,
        "destination": "Hong Kong"
    },
    {
        "company name": "British Airways",
        "date": "08/19/2024",
        "price": 881,
        "destination": "Chicago"
    },
    {
        "company name": "Blue Air",
        "date": "08/25/2024",
        "price": 492,
        "destination": "Toronto"
    },
    {
        "company name": "Blue Air",
        "date": "08/28/2024",
        "price": 492,
        "destination": "Singapore"
    },
    {
        "company name": "Blue Air",
        "date": "04/20/2024",
        "price": 417,
        "destination": "Chicago"
    },
    {
        "company name": "EasyJet",
        "date": "11/27/2024",
        "price": 440,
        "destination": "Chicago"
    },
    {
        "company name": "Ryanair",
        "date": "01/03/2024",
        "price": 341,
        "destination": "London"
    },
    {
        "company name": "EasyJet",
        "date": "10/10/2024",
        "price": 217,
        "destination": "Tokyo"
    },
    {
        "company name": "Ryanair",
        "date": "08/12/2024",
        "price": 970,
        "destination": "Chicago"
    },
    {
        "company name": "Wizz-Air",
        "date": "06/25/2024",
        "price": 143,
        "destination": "Dubai"
    },
    {
        "company name": "Ryanair",
        "date": "11/05/2024",
        "price": 728,
        "destination": "New York"
    },
    {
        "company name": "British Airways",
        "date": "12/05/2024",
        "price": 191,
        "destination": "Tokyo"
    },
    {
        "company name": "Ryanair",
        "date": "09/13/2024",
        "price": 471,
        "destination": "Bangkok"
    },
    {
        "company name": "EasyJet",
        "date": "03/28/2024",
        "price": 536,
        "destination": "Bangkok"
    },
    {
        "company name": "Blue Air",
        "date": "06/27/2024",
        "price": 467,
        "destination": "Hong Kong"
    },
    {
        "company name": "Blue Air",
        "date": "02/15/2024",
        "price": 879,
        "destination": "Sydney"
    },
    {
        "company name": "EasyJet",
        "date": "02/03/2024",
        "price": 989,
        "destination": "Beijing"
    },
    {
        "company name": "British Airways",
        "date": "08/29/2024",
        "price": 851,
        "destination": "Toronto"
    },
    {
        "company name": "EasyJet",
        "date": "10/16/2024",
        "price": 515,
        "destination": "Sydney"
    },
    {
        "company name": "British Airways",
        "date": "09/21/2024",
        "price": 832,
        "destination": "Paris"
    },
    {
        "company name": "Blue Air",
        "date": "12/01/2024",
        "price": 523,
        "destination": "Moscow"
    },
    {
        "company name": "British Airways",
        "date": "09/08/2024",
        "price": 898,
        "destination": "Toronto"
    },
    {
        "company name": "EasyJet",
        "date": "01/21/2024",
        "price": 163,
        "destination": "Toronto"
    },
    {
        "company name": "British Airways",
        "date": "12/18/2024",
        "price": 518,
        "destination": "Toronto"
    },
    {
        "company name": "Ryanair",
        "date": "11/13/2024",
        "price": 223,
        "destination": "Madrid"
    },
    {
        "company name": "Ryanair",
        "date": "01/15/2024",
        "price": 786,
        "destination": "Toronto"
    },
    {
        "company name": "Blue Air",
        "date": "10/23/2024",
        "price": 936,
        "destination": "Chicago"
    },
    {
        "company name": "Blue Air",
        "date": "07/08/2024",
        "price": 527,
        "destination": "Singapore"
    },
    {
        "company name": "Blue Air",
        "date": "01/25/2024",
        "price": 102,
        "destination": "Dubai"
    },
    {
        "company name": "EasyJet",
        "date": "02/06/2024",
        "price": 104,
        "destination": "Chicago"
    },
    {
        "company name": "EasyJet",
        "date": "01/14/2024",
        "price": 824,
        "destination": "London"
    },
    {
        "company name": "Blue Air",
        "date": "12/06/2024",
        "price": 326,
        "destination": "Beijing"
    },
    {
        "company name": "Ryanair",
        "date": "07/03/2024",
        "price": 584,
        "destination": "Madrid"
    },
    {
        "company name": "Blue Air",
        "date": "04/20/2024",
        "price": 382,
        "destination": "Los Angeles"
    },
    {
        "company name": "Wizz-Air",
        "date": "12/28/2024",
        "price": 316,
        "destination": "Bangkok"
    },
    {
        "company name": "EasyJet",
        "date": "04/20/2024",
        "price": 541,
        "destination": "Los Angeles"
    },
    {
        "company name": "Ryanair",
        "date": "06/15/2024",
        "price": 908,
        "destination": "Moscow"
    },
    {
        "company name": "EasyJet",
        "date": "12/04/2024",
        "price": 237,
        "destination": "Beijing"
    },
    {
        "company name": "British Airways",
        "date": "08/18/2024",
        "price": 477,
        "destination": "Los Angeles"
    },
    {
        "company name": "EasyJet",
        "date": "02/29/2024",
        "price": 344,
        "destination": "London"
    },
    {
        "company name": "EasyJet",
        "date": "03/22/2024",
        "price": 468,
        "destination": "Sydney"
    },
    {
        "company name": "Wizz-Air",
        "date": "11/24/2024",
        "price": 693,
        "destination": "Beijing"
    },
    {
        "company name": "Ryanair",
        "date": "02/15/2024",
        "price": 449,
        "destination": "Beijing"
    },
    {
        "company name": "Blue Air",
        "date": "01/06/2024",
        "price": 978,
        "destination": "Beijing"
    },
    {
        "company name": "British Airways",
        "date": "11/04/2024",
        "price": 362,
        "destination": "London"
    },
    {
        "company name": "Blue Air",
        "date": "02/16/2024",
        "price": 484,
        "destination": "Bangkok"
    },
    {
        "company name": "Ryanair",
        "date": "08/26/2024",
        "price": 647,
        "destination": "Los Angeles"
    },
    {
        "company name": "Wizz-Air",
        "date": "05/26/2024",
        "price": 662,
        "destination": "Toronto"
    },
    {
        "company name": "Blue Air",
        "date": "11/27/2024",
        "price": 636,
        "destination": "Bangkok"
    },
    {
        "company name": "Wizz-Air",
        "date": "11/15/2024",
        "price": 485,
        "destination": "Sydney"
    },
    {
        "company name": "British Airways",
        "date": "09/27/2024",
        "price": 929,
        "destination": "Toronto"
    },
    {
        "company name": "Ryanair",
        "date": "08/25/2024",
        "price": 568,
        "destination": "New York"
    },
    {
        "company name": "Blue Air",
        "date": "08/31/2024",
        "price": 441,
        "destination": "Madrid"
    },
    {
        "company name": "Ryanair",
        "date": "03/11/2024",
        "price": 830,
        "destination": "Chicago"
    },
    {
        "company name": "Ryanair",
        "date": "03/31/2024",
        "price": 787,
        "destination": "Toronto"
    },
    {
        "company name": "Ryanair",
        "date": "05/28/2024",
        "price": 718,
        "destination": "Chicago"
    },
    {
        "company name": "Wizz-Air",
        "date": "01/15/2024",
        "price": 364,
        "destination": "London"
    },
    {
        "company name": "British Airways",
        "date": "04/02/2024",
        "price": 547,
        "destination": "Bangkok"
    },
    {
        "company name": "Ryanair",
        "date": "02/05/2024",
        "price": 808,
        "destination": "Moscow"
    },
    {
        "company name": "Wizz-Air",
        "date": "08/15/2024",
        "price": 168,
        "destination": "Dubai"
    },
    {
        "company name": "Wizz-Air",
        "date": "01/15/2024",
        "price": 824,
        "destination": "Tokyo"
    },
    {
        "company name": "Ryanair",
        "date": "05/01/2024",
        "price": 703,
        "destination": "Paris"
    },
    {
        "company name": "Blue Air",
        "date": "10/18/2024",
        "price": 697,
        "destination": "Singapore"
    },
    {
        "company name": "Ryanair",
        "date": "01/25/2024",
        "price": 293,
        "destination": "Toronto"
    },
    {
        "company name": "EasyJet",
        "date": "10/08/2024",
        "price": 897,
        "destination": "Tokyo"
    },
    {
        "company name": "Blue Air",
        "date": "11/03/2024",
        "price": 949,
        "destination": "Bangkok"
    },
    {
        "company name": "British Airways",
        "date": "01/18/2024",
        "price": 456,
        "destination": "Chicago"
    }
]
